class ChallengeBoosterSelect {
  constructor(element) {
    this.element = element;
    this.counter = element.find("[data-behavior=booster-counter]");
    this.max = element.data("max");
    this.button = element.find("button");

    this.element.find("input[type=checkbox]").change((e) => {
      if (this.selected() > this.max) {
        return (e.target.checked = false);
      }

      this.update();
    });

    this.update();
  }

  update() {
    this.updateSubmit();
    this.updateCounter();
  }

  updateSubmit() {
    if (this.selected() == this.max) {
      this.button.attr("disabled", false);
    } else {
      this.button.attr("disabled", true);
    }
  }

  updateCounter() {
    this.counter.text(`${this.selected()} / ${this.max} selected`);
  }

  selected() {
    return this.element.find("input[type=checkbox]:checked").length;
  }
}

$(document).on("turbo:load", () => {
  $("[data-behavior=challenge-booster-select]").each(function () {
    new ChallengeBoosterSelect($(this));
  });
});

$(document).on("turbolinks:restore", () => {
  $("[data-behavior=challenge-booster-select]").each(function () {
    new ChallengeBoosterSelect($(this));
  });
});

$(document).on("modal:load", () => {
  $("[data-behavior=challenge-booster-select]").each(function () {
    new ChallengeBoosterSelect($(this));
  });
});
